import { availableEventSupportJobTypes } from '../../../../../../../../../helpers/availableJobTypeHelper'
import availableSizes from '../../../../../../../../../helpers/sizeHelper'
import availableShirtSizes from '../../../../../../../../../helpers/shirtSizeHelper'
import pastJob from '../../../../../dto/pastJobs'
import media from '../../../../../dto/media'

export default function() {
    let medias = []
    for (let i = 1; i <= 4; i++) {
        let photo = Object.assign({}, media)
        photo.type = 'photo'

        medias.push(photo)
    }
    let video = Object.assign({}, media)
    video.type = 'video'
    medias.push(video)

    return {
        availableEventSupportJobTypes,
        availableSizes,
        availableShirtSizes,
        profile: {
            category: 'event_support',
            height: null,
            size: null,
            shirtSize: null,
            shoesSize: null,
            fees: [],
            pastJobs: [{...pastJob}],
            media: medias,
            types: []
        },
        errors: {
            shirtSize: null,
            height: null,
            size: null,
            shoesSize: null,
            fee: null,
            types: null,
            pastJobs: []
        },
        showCropper: false,
        showVideoInput: false,
        videoObj: null,
        croppingImage: null,
        videoError: null
    }
}
